import React from 'react'
import Button from './index'

const EditButton = ({ onClick }) => {
  return (
    <Button
      type="button"
      btnClass="btn-icon"
      iconRight
      iconSize="1rem"
      iconClass="pi-pencil"
      onHandleClick={onClick}
    />
  )
}

export default EditButton
